import { createContext, ReactNode, useContext } from 'react';
import { ThemeProvider as Provider } from 'styled-components';

import { GlobalStyle } from '../../styles/globalStyles';
import themeSelector from '../../utils/themeSelector';
import { useEventContext } from './event.context';

type ThemeContextType = {
  producerId: number;
};

const ThemeContext = createContext({ } as ThemeContextType);

function ThemeProvider({ children }: { children: ReactNode }) {

  const { producerId } = useEventContext();

  return (
    <Provider theme={themeSelector({ producerId })}>
      <GlobalStyle />
      <ThemeContext.Provider value={{ producerId }}>
        {children}
      </ThemeContext.Provider>
    </Provider>
  );
}

ThemeProvider.displayName = 'ThemeProvider';
export const useThemeAppContext = (): ThemeContextType => useContext(ThemeContext);

export { ThemeProvider };
